<template>
    <el-dialog title="编辑" :visible.sync="downDataDialog" :close-on-click-modal="false" width="640px"
        id="dealChildDialog">
        <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
            <!-- <div class="seaerch-wrapper" style="min-height: 820px;"> -->
            <!-- 基本字段 -->
            <div class="seaerch-wrapper">
                <el-form :model="modalInfo.basicform" ref="ruleForm" label-width="130px">
                    <!-- <el-form :model="modalInfo.basicform" ref="ruleForm" class="add-form"> -->
                    <el-form-item v-for="(value, key) in modalInfo.props" :key="key" v-show="value.isChecked"
                        :label="value.prop == 'address' ? '详细地址' : value.label" :prop="value.prop"
                        :label-width="formLabelWidth" v-if="value.fieldClassify == 'basic' && value.isChecked" :rules="value.fieldRequired == 1 ? {
                            required: true, message: value.label + '不能为空', trigger: ['blur', 'change']
                        } : null">
                        <!-- 地址 -->
                        <v-distpicker :province="selectArea.province" :city="selectArea.city" :area="selectArea.area"
                            v-if="value.prop == 'selectAddress'" @province="onChangeProvince" @city="onChangeCity"
                            @area="onChangeArea"></v-distpicker>
                        <el-input style="width: 425px;" v-else-if="value.prop == 'address'"
                            v-model="modalInfo.basicform[value.prop]" size="small"></el-input>
                        <!-- 经销商层级 -->
                        <el-select style="width: 425px;" v-else-if="value.prop == 'level'" @change="changeLevel"
                            v-model="modalInfo.basicform[value.prop]" placeholder="请选择" size="small" clearable
                            :disabled="logintype == 'SHOP' || logintype == 'DEALER'">
                            <el-option v-for="item in levelList" v-show="item.id != 0" :key="item.id" :value="item.id"
                                :label="item.levelName"></el-option>
                        </el-select>
                        <!--上级经销商-->
                        <el-select v-else-if="value.prop == 'hlevelid'" style="width: 425px;"
                            :disabled="logintype == 'SHOP' || logintype == 'DEALER'"
                            v-model="modalInfo.basicform.hlevelid" filterable placeholder="请选择" size="small" clearable>
                            <el-option v-for="item in hlevelList" :key="item.id"
                                :disabled="modalInfo.basicform.dealername && modalInfo.basicform.dealername == item.dealername ? true : false"
                                :value="item.id" :label="item.dealername"></el-option>
                        </el-select>
                        <el-input v-else v-model="modalInfo.basicform[value.prop]" style="width: 425px;" size="small"
                            clearable
                            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
                    </el-form-item>
                </el-form>
                <!-- 新增字段 -->
                <el-form :model="modalInfo.addform" ref="ruleForm2">
                    <el-form-item v-for="(value, key) in modalInfo.props" :key="key + '2'" v-show="value.isChecked"
                        :label="value.label" :prop="value.prop" :label-width="formLabelWidth"
                        v-if="value.fieldClassify == 'add'" :rules="value.fieldRequired == '1' ? {
                            required: true, message: value.label + '不能为空', trigger: ['blur', 'change']
                        } : null">
                        <el-input style="width: 425px;" v-model="modalInfo.addform[value.prop]" size="small"
                            clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item class="item-btn">
                    <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
                    <el-button size="small" class="cancel" @click="downDataDialog = false">取 消</el-button>
                </el-form-item> -->
                </el-form>
            </div>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
            <el-button size="small" class="cancel" @click="downDataDialog = false">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import VDistpicker from 'v-distpicker'; //地区控件
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions } from 'vuex';
import { renderShopName } from "@/libs/renderCommon";

export default {
    name: "dearEditor",
    components: { VDistpicker },
    data() {
        return {
            downDataDialog: false,
            formLabelWidth: "130px",
            addfields: [],
            selectArea: {
                province: '', city: '', area: ''
            },
            modalInfo: {},
            basicField: [],//基础字段
            logintype: '',
        };
    },
    computed: {
        ...mapState({
            levelList: state => state.commonList.levelList,
            dealernameList: state => state.commonList.dealernameList
        }),
        hlevelList() {
            return JSON.parse(JSON.stringify(this.dealernameList))
        }
    },
    // created(){
    //
    // },
    methods: {
        startEditor(data) {
            this.initTableColum()
            this.handleEdit(data.id)
            this.logintype = JSON.parse(localStorage.getItem('userData')).logintype
            this.downDataDialog = true
        },
        ...mapActions(['reqDealernameList']),
        // 初始化表头
        forColum(titles) {
            for (var i = 0; i < titles.length; i++) {
                let field = {
                    id: titles[i].id,
                    label: titles[i].fieldname,
                    prop: titles[i].fieldvalue ? titles[i].fieldvalue : '',
                    isChecked: titles[i].isChecked ? true : false,
                    fieldRequired: titles[i].fieldRequired,
                    fieldClassify: titles[i].fieldClassify,
                    width: titles[i].fieldname.length > 4 ? titles[i].fieldname.length * 30 : 'auto'
                }
                if (titles[i].isChecked)
                    this.gridColumns.push(field)
                if (titles[i].fieldClassify == "basic") {
                    if (titles[i].fieldvalue == "address") {  //如果存在address的地址字段，就手动添加一个下拉选择的地址字段，用来渲染表单的下拉地址控件
                        let addressField = {
                            label: "地址",
                            prop: "selectAddress",
                            isChecked: titles[i].isChecked ? 1 : 0,
                            fieldRequired: titles[i].fieldRequired == '1' ? '1' : 0,
                            fieldClassify: 'basic',
                        }
                        this.basicField.push(addressField)
                    }
                    this.basicField.push(field)
                }
                if (titles[i].fieldClassify == "add")
                    this.addField.push(field)
            }
            for (let i = 0; i < this.gridColumns.length; i++) {
                // 渲染地址字段
                this.renderAddress(this.gridColumns[i]);
                // 经销商名称(点击可查看详情)
                renderShopName(this.gridColumns[i], 'dealername', null, this);
            }
            if (this.$route.query.isClicked == 'add') {
                this.newAddStore()
            }
        },
        // 字段为address的时候拼接：province + city + strict + address
        renderAddress(gridColumns) {
            if (gridColumns.prop == 'address') {
                gridColumns.width = 300;
                this.$set(gridColumns, "render", (h, params) => {
                    let province = params.row.province ? params.row.province : '';
                    let city = params.row.city ? params.row.city : '';
                    let strict = params.row.strict ? params.row.strict : '';
                    let address = params.row.address ? params.row.address : '';
                    return h('span', { attrs: { title: province + city + strict + address } }, province + city + strict + address);
                });
            }
        },
        initTableColum() {
            let query = { module: "DEALER" }
            fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule", query).then(res => {
                this.gridColumns = []; this.basicField = []; this.addField = [];
                if (res.status == "10000") {
                    this.forColum(res.data.add.data.concat(res.data.basic.data))
                }
            });
        },
        // 编辑事件
        handleEdit(shopId) {
            let query = {
                dealerid: shopId
            }
            fetchGet("/hcm/dealer/findById", query).then(res => {
                if (res.status == "10000" && res.data) {
                    this.isClicked = "edit";
                    this.linkpath = "编辑";
                    let dealernameList = this.dealernameList;
                    console.log(dealernameList);
                    let hlevelid = Number(res.data.hlevelid) == 0 ? null : Number(res.data.hlevelid)
                    this.modalInfo = {
                        flag: "edit",
                        props: this.basicField.concat(this.addField),
                        basicform: {
                            ...res.data,
                            dealerid: res.data.id,
                            selectAddress: res.data.address,
                            hlevelid: hlevelid,
                            level: Number(res.data.levelcode)
                        },
                        addform: res.data,
                        addField: this.addField
                    }
                    // 设置地区控件回显
                    let query = { level: this.modalInfo.basicform.level }
                    this.reqDealernameList(query)
                    this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.province + this.modalInfo.basicform.city + this.modalInfo.basicform.strict;
                    this.selectArea.province = this.modalInfo.basicform.province;
                    this.selectArea.city = this.modalInfo.basicform.city;
                    this.selectArea.area = this.modalInfo.basicform.strict;
                } else {
                    this.$message.info("接口数据为空，编辑回显数据是掉的接口！");
                }
            });
        },
        // 获取上级经销商名称和hlevelid
        getDealername(val) {
            let obj = {};
            obj = this.dealernameList.find((item) => {
                return item.id === val;
            });
            this.modalInfo.basicform.dealername = obj.dealername;
        },
        // 选区经销商层级获取上级经销商
        changeLevel(val) {
            this.modalInfo.basicform.hlevelid = ''
            let query = { level: val }
            this.reqDealernameList(query)
        },
        // 地区选区取值(省)
        onChangeProvince(a) {
            this.$set(this.modalInfo.basicform, "selectAddress", a.value)
            this.modalInfo.basicform.province = a.value;
        },
        onChangeCity(a) { //(市)
            this.modalInfo.basicform.city = a.value;
            this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.selectAddress + a.value;
        },
        onChangeArea(a) {  //(区)
            this.modalInfo.basicform.strict = a.value;
            this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.selectAddress + a.value;
        },
        addProp(obj, keys) {
            let addField = {}
            for (let i = 0; i < keys.length; i++) {
                if (obj[keys[i]]) {
                    addField[keys[i]] = obj[keys[i]]
                }
            }
            return addField
        },
        confirmClick() {
            let addFields = [];
            let addForm = {};
            if (this.modalInfo.addField) {
                for (let item of this.modalInfo.addField) {
                    addFields.push(item.prop)
                }
                addForm = this.addProp(this.modalInfo.addform, addFields);//新增字段属性
            }
            let query = {
                ...this.modalInfo.basicform,
                system: "BRM",
                level: this.modalInfo.basicform.level ? this.modalInfo.basicform.level : 0,
                hlevelid: this.modalInfo.basicform.hlevelid ? this.modalInfo.basicform.hlevelid : 0,
                addfield: JSON.stringify(addForm)
            }
            let _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$refs.ruleForm2.validate((valid2) => {
                        if (valid2) _this.reqNewAdd(query);
                        console.log('调用父组件')
                        setTimeout(() => {
                            this.$parent.dearFatherFun();
                            this.downDataDialog = false
                            return false;
                        }, 1000)

                    })
                } else {
                    return false;
                }
            });
        },
        // 新增/编辑请求
        reqNewAdd(query) {
            fetch({
                url: "/hcm/dealer/saveDealer",
                method: "post",
                data: query,
                noFormat: true,
                responseType: "text"
            })
                .then(result => {
                    let res = JSON.parse(result);
                    if (res.status == "10000") {
                        this.$message({
                            message: "操作成功！",
                            type: res.message
                        });
                        this.modalInfo.isShow = false;
                        this.$emit("reqTableData");
                    } else {
                        this.$message.error(res.message ? res.message : "操作失败！");
                    }
                })
                .catch(err => {
                    this.$message.error("请求失败！")
                });
        },
    }
};
</script>
<style lang="scss">
#dealChildDialog {
    .el-dialog__body {
        padding: 0px !important;
    }
}

.distpicker-address-wrapper {
    select {
        height: 32px;
        line-height: 32px;
        padding: 0 .75rem;
    }
}
</style>
